import { render, staticRenderFns } from "./BrbModal.vue?vue&type=template&id=98962fce&"
import script from "./BrbModal.vue?vue&type=script&lang=js&"
export * from "./BrbModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98962fce')) {
      api.createRecord('98962fce', component.options)
    } else {
      api.reload('98962fce', component.options)
    }
    module.hot.accept("./BrbModal.vue?vue&type=template&id=98962fce&", function () {
      api.rerender('98962fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbModal.vue"
export default component.exports